export default __webpack_public_path__ + "static/media/FoodAndBeverageBackground768x512.05cf9575.png";